import React, { useEffect, useState, useRef, VFC, ChangeEvent, useContext } from 'react';
import Modal from 'react-bootstrap/Modal';
import './quotesDialog.scss';
import { useAuth } from '@/lib/auth'
import { ReactComponent as SearchIcon } from '@/assets/steam/search-icon.svg';
import 'react-initials-avatar/lib/ReactInitialsAvatar.css';
import { ReactComponent as DownIcon } from '@/assets/steam/down-icon.svg';
import { ReactComponent as LastCoverageIcon } from '@/assets/steam/last-coverage.svg';
import { ReactComponent as Calendericon } from '@/assets/steam/date-frame.svg';
import { ReactComponent as Coverageicon } from '@/assets/steam/coverage-frame.svg';
import { ReactComponent as ProductIcon } from '@/assets/steam/product.svg';
import Utils from '@/utils/util';
import {  OverlayTrigger, Tooltip } from 'react-bootstrap';
import { saveAs } from 'file-saver';
import axios from 'axios';
import { ReactComponent as BookIcon } from '@/assets/steam/quotes.svg';
import { ReactComponent as DownloadIcon } from '@/assets/steam/download-grey.svg';
import { ReactComponent as EditIcon } from '@/assets/steam/edit.svg';
import { ReactComponent as BookFunnelIcon } from '@/assets/steam/book-funnel.svg';
import { ReactComponent as ProductFunnelicon } from '@/assets/steam/product-funnel.svg';
import { useGetUsersList } from '@/features/users/api/getProducts';
import { User } from '@/types';
import { useGetFunnelStagess } from '../api/getStages';
import AddQuotesDialog from './addNewQuote';
import { Quote } from '../types/indes';
import { useGetQuoteList } from '../api/quotesApi';
import { FUNNEL_TYPES, QUOTES_STATUS } from '@/utils/constants';

const QuotesDialog: VFC<{
    onConfirm: () => void;
    onClose: () => void;
    open: boolean;
    selectedFunnel?: any;
    funnetType?: any;
    productList?:any;
}> = ({ open, onClose, onConfirm, funnetType, selectedFunnel, productList }) => {
    const { user } = useAuth();
    const useGetUsersMutation = useGetQuoteList();
    const [usersList, setUsersList] = useState<User[]>([]);
    const useGetFunnelStagessMutation = useGetFunnelStagess();
    const [funnelStages, setFuneelStages] = useState<[]>([]);
    const [addNewQuote, setAddNewQuote] = useState<any>(false);
    const [editingQuote, setEditingQuote] = useState<any>(null);
    const [searchString, setSearchString] = useState('');
    const [filteredList, setFilteredList] = useState<Quote[]>([]);
    const [quoteList, setQuoteList] = useState<Quote[]>([]);
    const [totalPages, setTotalPages] = useState(0);
    const [totalRecords, setTotalRecords] = useState(0);
    const [tableCurrentIndex, setTableCurrentIndex] = useState(1);
    const [showData, setShowDetails] = useState('');

    useEffect(() => {
        if(selectedFunnel){
        getQuotesList(1, true)
    }
    }, [selectedFunnel])

    const searchUser = async (e: React.ChangeEvent<HTMLInputElement>) => {
        const searchString = e.target.value;
        setSearchString(searchString);
        const res = await useGetUsersMutation.mutateAsync({
            page: 1,
            perPage: 10,
            search: searchString,
            funnelId: selectedFunnel?.id
        });
        setQuoteList(res.list);
        if (searchString) {
            setFilteredList(res.list);
        } else {
            setFilteredList([]);
        }
        setTotalPages(res.totalPages);
        setTotalRecords(res.total);
    };

    const getQuotesList = async (pageIndex: number, reset = false,) => {
        const res = await useGetUsersMutation.mutateAsync({
            page: pageIndex,
            perPage: 10,
            search: searchString,
            funnelId: selectedFunnel?.id
        });

        setTotalPages(res.totalPages);
        setTotalRecords(res.total);
        if (reset) {
            setQuoteList(res.list);
            setTableCurrentIndex(1);
            if (searchString) {
                setFilteredList(res.list);
            }
        } else {
            setQuoteList(quoteList.concat(res.list));
            setTableCurrentIndex(pageIndex);
        }
    };


    const getQuantity = (item: any) => {
        return item.reduce((sum: any, product: any) => Number(sum) + Number(product.quantity), 0);
    }

    const getQuotesStatus = (id: any) => {
        if (id === QUOTES_STATUS.REQUESTED) {
            return 'Requested'
        } else if (id === QUOTES_STATUS.IN_PROGRESS) {
            return 'In progress'
        } else if (id === QUOTES_STATUS.REJECTED) {
            return 'rejected'
        } else if (id === QUOTES_STATUS.COMPLETED) {
            return 'Approved'
        } else {
            ''
        }
    }

    const getAssignedSubjects = (assignedSubjectIds: string[], product: any) => {
        if (product && product.subject && assignedSubjectIds && assignedSubjectIds.length > 0) {
            const assignedSubjects = product.subject.filter((sub: any) =>
                assignedSubjectIds.includes(sub.id)
            );

            const subjectNames = assignedSubjects.map((sub: any) => sub.name);

            const firstSubject = subjectNames.slice(0, 1);
            const remainingCount = subjectNames.length - 1;
            const allSubjects = subjectNames;

            return {
                firstSubject ,
                remainingCount: remainingCount > 0 ? remainingCount : 0,
                allSubjects
            };
        }

        return { firstSubject: [], remainingCount: 0 , allSubjects:[]};
    };

    const getAssignedClasses = (assignedClassIds: string[], product: any) => {
        if (product && product.subject && assignedClassIds && assignedClassIds.length > 0) {
            const allClasses = product.subject.reduce((classes: any[], subject: any) => {
                return classes.concat(subject.classes);
            }, []);


            const assignedClasses = allClasses.filter((cls: any) =>
                assignedClassIds.includes(cls.id)
            );
            const classNames = assignedClasses.map((cls: any) => cls.name);

            const firstClass = classNames.slice(0, 1);
            const remainingClassCount = classNames.length - 1;

            return {
                firstClass,
                remainingClassCount: remainingClassCount > 0 ? remainingClassCount : 0,
            };
        }
        return { firstClass: [], remainingClassCount: 0 };
    }
    const DownloadPdf = async (pdfLink: string, updatedDate: string) => {
        try {
          // Fetch the PDF file from the link
          const fileName = `Quotation - ${Utils.formatAnyDate(updatedDate)}.pdf`;

    // Create a temporary link element
    const link = document.createElement('a');
    link.href = pdfLink;
    link.target = '_blank';
    link.download = fileName; // Suggested file name for download
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
        } catch (error) {
          console.error('Error downloading the file:', error);
        }
      };

    const getContent = () => {
        return (
            <div className="view-quotes-dialog-content">
                <div className='search-container-quotes'>
                    <div className='search-filter-container'>

                        <span className="search-content">
                            <SearchIcon />
                            <input
                                type="text"
                                id="simple-search"
                                placeholder="Search quote.."
                                onChange={searchUser}
                                className="steam-search"
                            />
                        </span>
                    </div>
                    <div className='add-user-container'>
                        <button className='steam-button button-dark' onClick={() => { setAddNewQuote(true) }}>Request New Quote</button>

                    </div>
                </div>
                <div className='divider'></div>
                <div className='quotes-list'>
                    {quoteList && quoteList.length > 0 && quoteList.map((item: any) => {
                        return (
                            <div className='quotes-detail'>
                                <div className='quotes-title'>
                                    <div className='quote-name'>

                                        <div className='iconn'>
                                            <BookIcon /> 

                                        </div>
                                        <div className='datee'>
                                            <div className='bq'>
                                                {item.title}
                                            </div>
                                            <div className='dq'>
                                                {Utils.formatAnyDate(item.createdAt)}
                                            </div>
                                        </div>

                                    </div>
                                    <div className='quote-amount'>
                                        <div className='total-order-value'>
                                            <OverlayTrigger
                                                placement="top"
                                                overlay={
                                                    <Tooltip id="tooltip-id" className="service-provider-tooltip">
                                                        <div className="service-name">
                                                            ₹{Number(item.requestedPrice).toLocaleString('en-IN')}
                                                        </div>
                                                    </Tooltip>
                                                }
                                            >
                                                <span
                                                    className="tooltip-owner-name default"
                                                    style={{ cursor: 'pointer' }}
                                                >
                                                    Total Order Value <span>{Utils.convertDealSize(Number(item.requestedPrice))}</span>
                                                </span>
                                            </OverlayTrigger>
                                        </div>
                                        {Number(item?.statusId) !== QUOTES_STATUS.COMPLETED && (
                                            <div className='edit-button' onClick={() => {
                                                setEditingQuote(item);
                                                setAddNewQuote(true);
                                            }}>
                                                <EditIcon />
                                            </div>
                                        )}
                                    </div>

                                </div>
                                <div className='quote-current-status'>
                                    <div className='quote-type'>
                                        <div className='type-title'>
                                            Product type
                                        </div>
                                        <div className='type-name'>
                                            <div className={`funnels-bg ${selectedFunnel?.type === FUNNEL_TYPES.BOOK_FUNNEL ? 'change-bg' : ''}`}>  {selectedFunnel?.type !== FUNNEL_TYPES.BOOK_FUNNEL ? <BookFunnelIcon className='book-funnel-icon'/> :<ProductFunnelicon className='book-funnel-icon' /> }  {selectedFunnel?.type === FUNNEL_TYPES.BOOK_FUNNEL ? 'Books' : 'Platform'} </div>
                                        </div>

                                    </div>
                                    <div className='quote-type'>
                                        <div className='type-title'>
                                            Total quantity
                                        </div>
                                        <div className='type-name'>
                                            {selectedFunnel?.type === FUNNEL_TYPES.BOOK_FUNNEL ? `${getQuantity(item.productGroups)} Units` : '1 Unit'}
                                        </div>

                                    </div>
                                    <div className='quote-type'>
                                        <div className='type-title'>
                                            Quote status
                                        </div>
                                        <div className='type-name'>
                                            {getQuotesStatus(Number(item?.statusId))}  {Number(item?.statusId) === QUOTES_STATUS.COMPLETED &&<div onClick={()=>{DownloadPdf(item?.pdfLink, item.updatedAt)}}> <DownloadIcon /> </div>}   
                                        </div>

                                    </div>

                                    {Number(item?.statusId) === QUOTES_STATUS.COMPLETED && <div className='quote-type'>
                                        <div className='type-title'>
                                        PDF uploaded on 
                                        </div>
                                        <div className='type-name'>
                                        {Utils.formatAnyDate(item.updatedAt)}
                                        </div>

                                    </div>}

                                    <div className='quote-type'>
                                        <div className='type-title'>
                                        Expected Order Date
                                        </div>
                                        <div className='type-name'>
                                        {Utils.formatAnyDate(item.deliveryTime)}
                                        </div>

                                    </div>
                                    
                                    <div className='quote-type'>
                                        <div className='type-title'>
                                        Payment Percentage
                                        </div>
                                        <div className='type-name'>
                                        ADV: {item.advPercent || '-'} | PDA: {item.pdaPercent || '-'} | FNF: {item.fnfPercent || '-'}
                                        </div>
                                    </div>
                                    
                                    <div className='quote-type'>
                                        <div className='type-title'>
                                        FNF Timeline
                                        </div>
                                        <div className='type-name'>
                                        {item.fnfTimeline || '-'} {item.fnfTimeline ? 'Days after delivery' : ''}
                                        </div>
                                    </div>

                                     {/* <div className='quote-type align-top'>
                                        <div className='type-title'>
                                        City and State
                                        </div>
                                        <div className='type-name'>
                                       {(item.institute && item.institute.city && item.institute.city.state) ? `${item.institute.city.name}, ${item.institute.city.state.name}` : ''}
                                        </div>
                                    </div> */}

                                    {/* <div className='quote-type align-top'>
                                        <div className='type-title'>
                                      Payment Terms
                                        </div>
                                        <div className='type-name'>
                                       {(item.paymentTerms && item.paymentTerms !== '') ? item.paymentTerms : ''}
                                        </div>
                                    </div> */}

                                    <div className='quote-type align-top'>
                                        <div className='type-title'>
                                       Other Remarks
                                        </div>
                                        <div className='type-name'>
                                       {(item.otherDetails && item.otherDetails !== '') ? item.otherDetails : ''}
                                        </div>
                                    </div>

                                    

                                    {selectedFunnel?.type === FUNNEL_TYPES.BOOK_FUNNEL && <div className='quote-type'>
                                        <div className='type-title'>
                                            Total products
                                        </div>
                                        <div className='type-name'>
                                            {item.productGroups && item.productGroups.length}  <DownIcon onClick={()=>{
                                                
                                                if(showData === item.id){
                                                    setShowDetails('');
                                                    //setShowDetails(item.id)
                                                }else{
                                                    setShowDetails('');
                                                    setShowDetails(item.id)
                                                }
                                               }} />
                                        </div>


                                    </div>}

                                    {showData === item.id && item && item?.productGroups && item?.productGroups.length > 0 && <div className='product-details-tab'>
                    <div className='product-header'>
                        <div className='name'>
                            Target Products
                        </div>
                        <div className='qty'>
                            Qty
                        </div>
                        <div className='sub'>
                            Subject
                        </div>
                        <div className='class'>
                            Class
                        </div>
                        <div className='price'>
                            Price
                        </div>

                    </div>

                    {item && item?.productGroups && item?.productGroups.length > 0 && item?.productGroups.map((item: any, index: any) => {
                        const { firstSubject, remainingCount,allSubjects } = getAssignedSubjects(item.subject, item.product);
                        const { firstClass, remainingClassCount } = getAssignedClasses(item.class, item.product);
                        return (
                            <div className='product-values' key={index}>
                                <div className='name'>
                                    {item?.product?.name}
                                </div>
                                <div className='qty'>
                                    x{item.quantity}
                                </div>
                                <div className='sub'>

                                    <div className="table-contact  font-valeu">
                                        <div className='fix-width'>
                                            {firstSubject}
                                        </div>
                                        {remainingCount > 0 && (
                                            <span className='show-count'>
                                                +{remainingCount}
                                            </span>
                                        )}
                                    </div>
                                </div>
                                <div className='class'>
                                    <div className="table-contact font-valeu">
                                        <div className='fix-width'>
                                            {firstClass}
                                        </div>
                                        {remainingCount > 0 && (
                                            <span className='show-count'>
                                                +{remainingClassCount}
                                            </span>
                                        )}
                                    </div>
                                </div>
                                <div className='price'>
                                    {item?.price}
                                </div>
                            </div>
                        )
                    })}




                </div>}

                                </div>

                            </div>)
                    })}

                    {quoteList && quoteList.length === 0 && <div className='no-data-found item-alignment'> No Data!</div>}
                </div>
            </div>
        );
    };

    return (
        <>
            <Modal
                show={open}
                onHide={() => { onClose() }}
                className={`steam-modal-dialog view-history-dialog `}
                size="sm"

            >
                <Modal.Header closeButton >
                    <div className="model-header-tab">
                        <div className="modal-header-title">
                            Quote Record
                        </div>
                        <div className="modal-header-desc">
                            {/* {'Lorem ipsum dolor sit amet, consectetur elit, sed'} */}
                        </div>
                    </div>
                </Modal.Header>
                <Modal.Body >{getContent()}</Modal.Body>
            </Modal>

            {addNewQuote && <AddQuotesDialog 
                productList={productList} 
                selectedFunnel={selectedFunnel} 
                editingQuote={editingQuote}
                open={addNewQuote} 
                onClose={() => { 
                    setAddNewQuote(false);
                    setEditingQuote(null);
                }} 
                onConfirm={() => { 
                    setAddNewQuote(false);
                    setEditingQuote(null);
                    getQuotesList(1, true);
                }} 
            />}
        </>
    );
};




export default QuotesDialog;
